
export type MatchEventType =
  | "cta"
  | "input"
  | "exit"
  | "withdrawal"
  | "challenge_init"
  | "challenge_solution"
  | "challenge_requested_solution"
  | "challenge_error"
  | "challenge_hint";

export type ChallengeEventType =
  | "challenge_init"
  | "challenge_solution"
  | "challenge_requested_solution"
  | "challenge_error"
  | "challenge_hint";

export const ChallengeEventTypes: ChallengeEventType[] = [
  "challenge_init",
  "challenge_error",
  "challenge_hint",
  "challenge_solution",
  "challenge_requested_solution",
];

export type ChallengeEndType = "challenge_solution" | "challenge_requested_solution";

Object.freeze(ChallengeEventTypes);

export type MatchEvent = {
  id: string;
  match?: string;
  date_created: string;
  type: MatchEventType;
  target_id?: string;
  value?: string;
};

export type MatchEventCreate = Omit<MatchEvent, "date_created" | "id"> & {
  match: string;
};

/**
 *  An object where keys are match IDs and values are arrays of related MatchEvent objects.
 */
export type MatchToEventsMap = Record<string, MatchEvent[]>;


